import { render, staticRenderFns } from "./WhatToExpect-fr.vue?vue&type=template&id=2e64d403&"
import script from "./WhatToExpect-fr.vue?vue&type=script&lang=js&"
export * from "./WhatToExpect-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports